<template>
  <v-container class="pa-0 ma-0 industry-page">
    <v-img
      src="@/assets/images/entrypages/pexels-bongkarn-thanyakij-3843352.jpg"
      height="480"
      position="center center"
    ></v-img>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
